import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Guard, GuardProps } from './guard.component';

export interface GuardService<S> {
    checkPermissions: (permissions: S) => boolean;
}

export interface GuardRedirectProps<S> extends GuardProps<S> {
    redirect?: string;
}

export const GuardRedirect = <S,>(props: GuardRedirectProps<S>) => {
    const navigate = useNavigate();
    const isAllowed = props.guardService.checkPermissions(props.requiredPermissions);

    useEffect(() => {
        if (!isAllowed && props.redirect !== undefined) {
            setTimeout(() => navigate(props.redirect as string), 0);
        }
    }, []);

    return <Guard<S> {...props} />;
};
